export type EducationHostedFormProps = {
  formStep: EducationHostedFormSteps
}

export enum EducationHostedFormSteps {
  SELECT_ORGANISATION = 'select_organisation',
  ADD_ORGANISATION = 'add_organisation',
  ORGANISATION_ADDRESS = 'organisation_address',
  AGENT_DETAILS = 'agent_details',
  OTP = 'otp',
  PROCESSING_PAGE = 'processing_page',
  DOCUMENT_UPLOAD = 'document_upload',
  TERMS = 'terms',
  APPROVED = 'approved',
  PENDING_APPROVE = 'pending_approve',
  REJECTED = 'rejected',
  OTP_MAX_ATTEMPTS_EXCEEDED = 'otp_max_attempts_exceeded'
}

export type EducationHostedFormModel = {
  country: string
  organisationId: string
  firstName: string
  lastName: string
  email: string
  dateOfBirth: Date | null
  validationSubmissionDocumentId?: string
  organisationName?: string
  organisationWebsite?: string
  organisationAddressLine1?: string
  organisationAddressLine2?: string
  organisationCity?: string
  organisationState?: string
  organisationPostalCode?: string
  otpJwt?: string
}
